<template>
<div class="login">
  <body
    class="account-page"
    style="font-family: 'CircularStd', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;"
  >
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content" style="padding: 35px 0;">
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <router-link to="/index">
              <img v-bind:src="logoText" :alt="appTitle" />
            </router-link>
            <!-- {{imgLogo}} -->
          </div>
          <!-- /Account Logo -->

          <div class="account-box">
            <div class="account-wrapper">
              <h3 class="account-title">Forgot Password</h3>
              <p class="account-subtitle">Can not access your account?</p>

              <!-- Account Form -->
              <form @submit.prevent="requestForgot" class="was-validated">
                <div class="form-group">
                  <label>Email Address</label>
                  <input class="form-control" type="email" v-model="fields.username" required />
                </div>
                <div class="form-group text-center">
                  <button
                    :disabled="isDisabled == 1"
                    class="btn btn-primary account-btn"
                    type="submit"
                  >Request</button>
                </div>
                <div class="account-footer">
                  <p>
                    Don't have an account yet?
                    <router-link to="/register">Register</router-link>
                  </p>
                </div>
              </form>
              <!-- /Account Form -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </body>
</div>
</template>

<script>
// import { getXAuthToken, setXAuthToken, removeXAuthToken } from "@/utils/auth";

export default {
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      logoText: process.env.VUE_APP_LOGO_TEXT,
      // imgLogo:
      //   ' <img src="@/' + this.logoText + '" alt="' + this.appTitle + '" />',
      isDisabled: 0,
      fields: {
        username: ""
      }
    };
  },
  methods: {
    async requestForgot() {
      this.isDisabled = await 1;
      await this.$store
        .dispatch("forgot/requestForgot", this.fields) // sesuai kan dengan method di API
        .then(response => {
          this.fields.username = "";

          console.log("response", response);
          if (response["status"] == 200) {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.isDisabled = 0;
              // this.$router.push("/index");
            });
          }
        })
        .catch(error => {
          this.isDisabled = 0;
        });
    }
  },
  name: "forgot"
};
</script>


// WEBPACK FOOTER //
// src/views/forgot/index.vue